import React from "react";

export default function TimeLastDrink({ hours, minutes, updateTimeChange }) {
  function validatedValue(value) {
    value = value.replace(/[^0-9]/g, "");
    if (isNaN(value) || value < 0) {
      return null;
    } else {
      return value;
    }
  }

  return (
    <>
      <div className="text-sm sm:text-base mb-2 cursor-default" id="timeLabel">
        Temps écoulé depuis le dernier verre
      </div>
      <div
        className="flex items-center gap-2 w-full"
        aria-labelledby="timeLabel"
      >
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          className="w-12 text-center py-2 px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300 focus:border-slate-500"
          onChange={(e) =>
            updateTimeChange(validatedValue(e.target.value), minutes)
          }
          value={hours}
          aria-label="Heures écoulées"
          aria-describedby="hoursDescription"
        />
        <div className="text-sm sm:text-base font-bold cursor-default">
          heures
        </div>
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          className="w-12 ml-2 text-center py-2 px-2 font-bold rounded-lg text-base sm:text-lg focus:outline-none focus:ring focus:ring-slate-300 focus:border-slate-500"
          onChange={(e) =>
            updateTimeChange(hours, validatedValue(e.target.value))
          }
          value={minutes}
          aria-label="Minutes écoulées"
          aria-describedby="minutesDescription"
        />
        <div className="text-sm sm:text-base font-bold cursor-default">
          minutes
        </div>
      </div>
      <div id="hoursDescription" className="hidden">
        Saisissez le nombre d'heures depuis votre dernier verre.
      </div>
      <div id="minutesDescription" className="hidden">
        Saisissez le nombre de minutes depuis votre dernier verre.
      </div>
    </>
  );
}
